import { useState } from "react";
import styles from "./collapsible-json-viewer.module.css";

interface CollapsibleJsonViewerProps {
  data: any;
  label?: string;
}

export const CollapsibleJsonViewer = ({ data, label = "View JSON" }: CollapsibleJsonViewerProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.container}>
      <button onClick={toggleExpanded} className={styles.toggleButton}>
        <span className={styles.arrow}>{isExpanded ? "▼" : "▶"}</span>
        {label}
      </button>
      {isExpanded && (
        <pre className={styles.jsonContent}>
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
};
